import React from "react";
import { Route } from "react-router-dom";
import PageAdminUsuarios from "../pages/Admin/Usuarios";
import PageAdminUsuarioForm from "../pages/Admin/Usuarios/Form";
import PageAdminLogs from "../pages/Admin/Logs";
import PageAdminPrazo from "../pages/Admin/Prazo";

// Rotas do domínio Admin. Exporta só a lista de elementos <Route> (sem
// <BrowserRouter>/<Switch> próprios) para serem montadas dentro do único
// <Switch> consolidado em pages/Principal/index.js (mesmo padrão da Fase 5).
const routesAdmin = [
    <Route key="admin-usuarios" exact path="/admin/usuarios" component={PageAdminUsuarios} />,
    <Route key="admin-usuarios-novo" exact path="/admin/usuarios/novo" component={PageAdminUsuarioForm} />,
    <Route key="admin-usuarios-editar" exact path="/admin/usuarios/:id" component={PageAdminUsuarioForm} />,
    <Route key="admin-logs" exact path="/admin/logs" component={PageAdminLogs} />,
    <Route key="admin-prazo" exact path="/admin/prazo" component={PageAdminPrazo} />
];

export default routesAdmin;
